import { Routes, RouterModule } from "@angular/router";
import { IDStationComponent } from "./index";
import { PhotoStationComponent } from "./photostation/photostation.component";
import { AuthguardService } from "../master/services";

export const IDStationRoutes: Routes = [
	{ path: "", redirectTo: "/idstation/station", pathMatch: "full" },
	{
		path: "station",
		data: { title: "Photo Station" },
		component: PhotoStationComponent,
		canActivate: [AuthguardService],
	},
];
